import { useEffect, useState } from "react";
import api from "../../../../../services/api";
import { useAuth } from "../../../../../hooks/auth";
import { useToast } from "../../../../../hooks/toast";
import refreshToken from "../../../../../utils/refreshToken";
import { useHistory } from "react-router-dom";
import { FieldLabel, GuaranteePills } from "../../../../../components/propertyDescription/descriptionUi";
import {
  buildGuaranteeToggleEvent,
  isGuaranteeSelected,
} from "../../../../../utils/guaranteeSelection";

interface IGuarantee {
  id: number;
  name: string;
  documents: string[];
  description: string;
}

interface IProps {
  selectedGuarantees: number[];
  onChange: (event: { target: { checked: boolean; value: string } }) => void;
}

function GuaranteesSection({ onChange, selectedGuarantees }: IProps) {
  const { access_token, dateToExpires, user } = useAuth();
  const { addToast } = useToast();
  const history = useHistory();

  const [isFetching, setIsFetching] = useState(false);
  const [fetchedGuarantees, setFetchedGuarantees] = useState<IGuarantee[]>([]);

  useEffect(() => {
    async function loadGuarantees() {
      setIsFetching(true);
      try {
        const token = await refreshToken(dateToExpires, access_token);

        api.defaults.headers.authorization = `Bearer ${
          !!token ? token : access_token
        }`;

        const response = await api.get("/api/adm/guarantees");

        setFetchedGuarantees(response.data.data);
      } catch (err: any) {
        if (!!err.response?.data.message) {
          addToast({
            title: err.response.data.message,
            type: "error",
          });
        }
      }
      setIsFetching(false);
    }

    if (!!user) {
      loadGuarantees();
    } else {
      history.push("/");
    }
  }, [dateToExpires, access_token, user, history, addToast]);

  return (
    <div>
      <FieldLabel>Garantias disponíveis</FieldLabel>
      {isFetching ? (
        <p className="text-sm text-slate-500">Carregando...</p>
      ) : (
        <GuaranteePills
          items={fetchedGuarantees}
          isSelected={(id) => isGuaranteeSelected(selectedGuarantees, id)}
          onToggle={(id, selected) =>
            onChange(buildGuaranteeToggleEvent(id, selected))
          }
        />
      )}
    </div>
  );
}

export default GuaranteesSection;
